import { useEffect } from 'react';
import { ContactType } from '../hooks'
import { findContactCategoryName } from 'views/utils/enums'
import { FormikProps } from 'formik';

export type DisplayItemProps = {
  label: string;
  value: string;
  hidden?: boolean;
};

export const useContactConfirm = (formik : FormikProps<ContactType>) => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const displayInfo = {
    ContactDetailsType: [
      { label: 'お問い合わせ内容', value: formik.values.contactDetails },
    ] as DisplayItemProps[],
  };

  return { displayInfo };
};